import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { loadFundData, setSort, setLevel } from "../../actions/data";
import {
  getFundData,
  getSortDirection,
  getSortColumn,
  getLevelData,
} from "../../reducers/data";
import { getVersion } from "../../reducers/params";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faGlobe,
  faGlobeAmericas,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import "./App.css";

library.add(faStar, faGlobe, faGlobeAmericas, faFilePdf);

class App extends PureComponent {
  componentWillMount() {
    this.props.loadFundData();
  }

  setSampleParam(param) {
    this.props.setSampleParam(param);
  }

  getFundData() {
    this.props.loadfundData();
  }

  setSortData(column) {
    this.props.setSort(column);
  }

  setLevelData(type) {
    this.props.setLevel(type);
  }

  setTblHeadClass(type) {
    if (type === this.props.sortColumn && this.props.sortDirection === "DESC") {
      return "des";
    } else if (
      type === this.props.sortColumn &&
      this.props.sortDirection === "ASC"
    ) {
      return "asc";
    } else {
      return "";
    }
  }

  setLevelClass(level) {
    return level === this.props.levelData
      ? "button-selected"
      : "button-not-selected";
  }

  renderStars(param) {
    switch (param) {
      case 5:
        //  style={{ textAlign: 'center', whiteSpace: 'nowrap' }
        return (
          <div>
            <FontAwesomeIcon className="fa" icon="star" />
            <FontAwesomeIcon className="fa" icon="star" />
            <FontAwesomeIcon className="fa" icon="star" />
            <FontAwesomeIcon className="fa" icon="star" />
            <FontAwesomeIcon className="fa" icon="star" />
          </div>
        );
      case 4:
        return (
          <div>
            <FontAwesomeIcon className="fa" icon="star" />
            <FontAwesomeIcon className="fa" icon="star" />
            <FontAwesomeIcon className="fa" icon="star" />
            <FontAwesomeIcon className="fa" icon="star" />
          </div>
        );
      case 3:
        return (
          <div>
            <FontAwesomeIcon className="fa" icon="star" />
            <FontAwesomeIcon className="fa" icon="star" />
            <FontAwesomeIcon className="fa" icon="star" />
          </div>
        );
      case 2:
        return (
          <div>
            <FontAwesomeIcon className="fa" icon="star" />
            <FontAwesomeIcon className="fa" icon="star" />
          </div>
        );
      case 1:
        return (
          <div>
            <FontAwesomeIcon className="fa" icon="star" />
          </div>
        );
      default:
    }
  }

  renderGlobeAmericass(param) {
    switch (param) {
      case 5:
        //  style={{ textAlign: 'center', whiteSpace: 'nowrap' }
        return (
          <div>
            <FontAwesomeIcon className="fas" icon="globe-americas" />
            <FontAwesomeIcon className="fas" icon="globe-americas" />
            <FontAwesomeIcon className="fas" icon="globe-americas" />
            <FontAwesomeIcon className="fas" icon="globe-americas" />
            <FontAwesomeIcon className="fas" icon="globe-americas" />
          </div>
        );
      case 4:
        return (
          <div>
            <FontAwesomeIcon className="fas" icon="globe-americas" />
            <FontAwesomeIcon className="fas" icon="globe-americas" />
            <FontAwesomeIcon className="fas" icon="globe-americas" />
            <FontAwesomeIcon className="fas" icon="globe-americas" />
          </div>
        );
      case 3:
        return (
          <div>
            <FontAwesomeIcon className="fas" icon="globe-americas" />
            <FontAwesomeIcon className="fas" icon="globe-americas" />
            <FontAwesomeIcon className="fas" icon="globe-americas" />
          </div>
        );
      case 2:
        return (
          <div>
            <FontAwesomeIcon className="fas" icon="globe-americas" />
            <FontAwesomeIcon className="fas" icon="globe-americas" />
          </div>
        );
      case 1:
        return (
          <div>
            <FontAwesomeIcon className="fas" icon="globe-americas" />
          </div>
        );
      default:
        return null;
    }
  }
  renderNumFunds(param) {
    return param > 0 ? new Intl.NumberFormat("en-US").format(param) : "";
  }

  renderTableHeader(dataLevel) {
    switch (dataLevel) {
      case "overall":
        return this.renderOverallTableHeader();
      case "history":
        return this.renderHistoryTableHeader();
      default:
        break;
    }
  }

  renderOverallTableHeader() {
    return (
      <thead>
        <tr className="overall first">
          <th
            style={{ height: "45px", borderBottom: "0px" }}
            colSpan="2"
            className="center"
          >
            Fund Information
            <br />
          </th>
          <th
            style={{ height: "45px", borderTop: "0px" }}
            colSpan="3"
            className="center"
          >
            Morningstar <br />
          </th>
        </tr>
        <tr className="overall second">
          <th
            colSpan="1"
            className={"center-borderleft " + this.setTblHeadClass("ticker")}
            onClick={() => this.setSortData("ticker")}
          >
            Ticker
          </th>
          <th
            colSpan="1"
            className={"center-borderleft " + this.setTblHeadClass("name")}
            onClick={() => this.setSortData("name")}
          >
            Fund
          </th>
          <th
            colSpan="1"
            className={
              "center-borderleft " + this.setTblHeadClass("morningStarCategory")
            }
            onClick={() => this.setSortData("morningStarCategory")}
          >
            Morningstar U.S. Fund Category{" "}
          </th>
          <th
            colSpan="1"
            className={
              "center-borderleft " +
              this.setTblHeadClass("numberOfInvestmentsInCategoryTotal")
            }
            style={{ textAlign: "center", whiteSpace: "nowrap" }}
          >
            Overall # of Funds
          </th>
          <th
            colSpan="1"
            className={
              "center-borderleft " + this.setTblHeadClass("mstarRatOverall")
            }
            onClick={() => this.setSortData("mstarRatOverall")}
          >
            Overall Rating
          </th>
          {/* <th colSpan='1' className={'center-borderleft ' + this.setTblHeadClass('esgRating')} onClick={() => this.setSortData('esgRating')}>
            ESG Rating
          </th> */}
        </tr>
      </thead>
    );
  }
  renderHistoryTableHeader() {
    return (
      <thead>
        <tr className="history first">
          <th style={{ height: "45px" }} colSpan="3" className="center">
            <br />
          </th>
          <th style={{ height: "45px" }} colSpan="2" className="center">
            3-Year
            <br />
          </th>
          <th style={{ height: "45x" }} colSpan="2" className="center">
            5-Year
            <br />
          </th>
          <th style={{ height: "45px" }} colSpan="2" className="center">
            10-Year
            <br />
          </th>
        </tr>
        <tr className="history second">
          <th
            colSpan="1"
            className={"center-borderleft " + this.setTblHeadClass("ticker")}
            onClick={() => this.setSortData("ticker")}
          >
            Ticker
          </th>
          <th
            colSpan="1"
            className={"center-borderleft " + this.setTblHeadClass("name")}
            onClick={() => this.setSortData("name")}
          >
            Fund
          </th>
          <th
            colSpan="1"
            className={
              "center-borderleft " + this.setTblHeadClass("morningStarCategory")
            }
            onClick={() => this.setSortData("morningStarCategory")}
          >
            Morningstar U.S. Fund
            <br />
            Category{" "}
          </th>
          <th
            colSpan="1"
            className={
              "center-borderleft " + this.setTblHeadClass("mstarRatOverall")
            }
            onClick={() => this.setSortData("mstarRatOverall")}
          >
            Overall Morningstar
            <br /> Rating
          </th>
          <th
            colSpan="1"
            className={
              "center-borderleft " +
              this.setTblHeadClass("numberOfInvestmentsOverall")
            }
            style={{ textAlign: "center", whiteSpace: "nowrap" }}
          >
            Overall <br /> # of Funds
          </th>
          <th
            colSpan="1"
            className={
              "center-borderleft " + this.setTblHeadClass("mstarRatYrs05")
            }
            onClick={() => this.setSortData("mstarRatYrs05")}
          >
            Overall Morningstar
            <br /> Rating
          </th>
          <th
            colSpan="1"
            className={
              "center-borderleft " +
              this.setTblHeadClass("numberOfInvestmentsYrsFive")
            }
            style={{ textAlign: "center", whiteSpace: "nowrap" }}
          >
            Overall
            <br /> # of Funds
          </th>
          <th
            colSpan="1"
            className={
              "center-borderleft " + this.setTblHeadClass("mstarRatYrs10")
            }
            onClick={() => this.setSortData("mstarRatYrs10")}
          >
            Overall Morningstar
            <br /> Rating
          </th>
          <th
            colSpan="1"
            className={
              "center-borderleft " +
              this.setTblHeadClass("numberOfInvestmentsYrsTen")
            }
            style={{ textAlign: "center", whiteSpace: "nowrap" }}
          >
            Overall <br /># of Funds
          </th>
        </tr>
      </thead>
    );
  }
  renderEntities(level) {
    if (this.props.fundData) {
      if (this.props.sortColumn === "ticker") {
        const column = "ticker";
        this.props.fundData.sort((a, b) => a[column].localeCompare(b[column]));
      } else if (this.props.sortColumn === "name") {
        this.props.fundData.sort((a, b) =>
          a[this.props.sortColumn].localeCompare(b[this.props.sortColumn]),
        );
      } else if (this.props.sortColumn === "mstarRatOverall") {
        this.props.fundData.sort(
          (a, b) =>
            b["mstarRatOverall"] - a["mstarRatOverall"] ||
            a["ticker"].localeCompare(b["ticker"]),
        );
      } else if (this.props.sortColumn === "morningStarCategory") {
        const column = "morningStarCategory";
        this.props.fundData.sort((a, b) => a[column].localeCompare(b[column]));
      } else {
        this.props.fundData.sort(
          (a, b) => a[this.props.sortColumn] - b[this.props.sortColumn],
        );
      }
      if (this.props.sortDirection === "DESC") {
        this.props.fundData.reverse();
      }

      if (level === "overall") {
        return this.props.fundData.map((entity) => (
          <tr className="overall" key={entity.externalID}>
            <td rowname="Ticker">
              <a href={entity.fundPageURL} target="_new">
                {entity.ticker}
              </a>
            </td>
            <td rowname="Fund Name" className="textLeft .d-sm-none .d-md-block">
              {" "}
              <div>
                {" "}
                <a href={entity.fundPageURL} target="_new">
                  {" "}
                  {entity.name.replace(/&amp;/g, "&")}
                </a>{" "}
              </div>
            </td>
            <td rowname="MorningStar Category" className="textLeft">
              <div>{entity.morningStarCategory}</div>
            </td>
            <td
              rowname="MorningStar # Investments Overall"
              className="textCenter"
            >
              <div>
                {this.renderNumFunds(entity.numberOfInvestmentsOverall)}
              </div>
            </td>
            <td rowname="MorningStar Rating Overall" className="textCenter">
              <div>{this.renderStars(entity.mstarRatOverall)}</div>
            </td>
            {/* <td rowname='MorningStar Rating Overall' className='textCenter'>
              <div>{this.renderGlobeAmericass(entity.esgRating)}</div>
            </td> */}
          </tr>
        ));
      } else if (level === "history") {
        return this.props.fundData.map((entity) => (
          <tr className="history" key={entity.externalID}>
            <td rowname="Ticker">
              <a href={entity.fundPageURL} target="_new">
                {entity.ticker}
              </a>
            </td>
            <td rowname="Fund Name" className="textLeft">
              <div>{entity.name.replace(/&amp;/g, "&")}</div>
            </td>
            <td rowname="MorningStar Category" className="textLeft">
              <div>{entity.morningStarCategory}</div>
            </td>
            <td rowname="MorningStar Rating Overall" className="textCenter">
              <div>
                {" "}
                {entity.mstarRatYrs03 >= 1
                  ? this.renderStars(entity.mstarRatYrs03)
                  : "N/A"}{" "}
              </div>
            </td>
            <td rowname="MorningStar  # of Funds" className="textCenter">
              <div>
                {entity.mstarRatYrs03 >= 1
                  ? this.renderNumFunds(entity.numberOfInvestmentsYrs03)
                  : "N/A"}
              </div>
            </td>
            <td rowname="MorningStar Rating 5 Years" className="textCenter">
              <div>
                {" "}
                {entity.mstarRatYrs05 >= 1
                  ? this.renderStars(entity.mstarRatYrs05)
                  : "N/A"}{" "}
              </div>
            </td>
            <td
              rowname="MorningStar  # of Funds 5 years"
              className="textCenter"
            >
              <div>
                {" "}
                {entity.mstarRatYrs05 >= 1
                  ? this.renderNumFunds(entity.numberOfInvestmentsYrs05)
                  : "N/A"}
              </div>
            </td>
            <td rowname="MorningStar Rating 10 Years" className="textCenter">
              <div>
                {" "}
                {entity.mstarRatYrs10 >= 1
                  ? this.renderStars(entity.mstarRatYrs10)
                  : "N/A"}{" "}
              </div>
            </td>
            <td
              rowname="MorningStar # of Funds 10 Years"
              className="textCenter"
            >
              <div>
                {" "}
                {entity.mstarRatYrs10 >= 1
                  ? this.renderNumFunds(entity.numberOfInvestmentsYrs10)
                  : "N/A"}
              </div>
            </td>
          </tr>
        ));
      } else {
        return null;
      }
    } else return null;
  }

  render() {
    if (this.props.fundData.length > 0) {
      let cts = this.props.fundData[0].morningStarDate;
      let cdate = new Date(cts).toLocaleDateString();
      return (
        <div className="morn-star">
          <div className="morn-star-toolbar">
            <div className="morn-star-toolbar__actions">
              <button
                onClick={() => this.setLevelData("overall")}
                className={this.setLevelClass("overall")}
                type="button"
              >
                Overall
              </button>
              <button
                onClick={() => this.setLevelData("history")}
                className={this.setLevelClass("history")}
                type="button"
              >
                History
              </button>
            </div>
            <div className="morn-star-toolbar__meta">
              <div className="titleText">As of date: {cdate}</div>
              <div className="pdfLink">
                <a
                  href="https://dataspanapi.wisdomtree.com/pdr/documents/PERFORMANCE_REPORT/WTAM/US/EN-US/MORNINGSTARRATINGS/"
                  target="_new"
                >
                  <FontAwesomeIcon
                    icon="file-pdf"
                    size="1x"
                    style={{ color: "#050139" }}
                  />{" "}
                  Download Morningstar Ratings PDF
                </a>
              </div>
            </div>
          </div>
          <div className="morn-star-details table-responsive">
            <table
              id="table-to-xls"
              className={`table morningstar-table morningstar-table--${this.props.levelData}`}
            >
              {this.renderTableHeader(this.props.levelData)}

              <tbody>{this.renderEntities(this.props.levelData)}</tbody>
            </table>
            <div className={"comptext"}>
              {
                "Past performance is not indicative of future results.  Overall Morningstar Ratings are based on Risk-Adjusted Return."
              }
            </div>
            <div className={"mstartext"}>
              {
                "The Morningstar Rating™ for funds, or “star rating,” is calculated for managed products with at least a three-year history. Exchange-traded funds and open-ended mutual funds are considered a single population for comparative purposes. It is calculated based on a Morningstar Risk-Adjusted Return measure that accounts for variation in a managed product’s monthly excess performance, placing more emphasis on downward variations and rewarding consistent performance. The top 10% of products in each product category receive five stars, the next 22.5% receive four stars, the next 35% receive three stars, the next 22.5% receive two stars, and the bottom 10% receive one star. The Overall Morningstar Rating for a managed product is derived from a weighted average of the performance figures associated with its three- and five-year Morningstar Rating metrics. The weights are: 100% three-year rating for 36-59 months of total returns, 60% five-year rating/40% three-year rating for 60-119 months of total returns."
              }
            </div>
            <div className={"esgText"}>
              {
                "The Morningstar Sustainability Rating is a measure of the financially material environmental, social and governance, or ESG, risks in a portfolio relative to a portfolio's peer group. "
              }
            </div>
            <div className={"esgText"}>
              {
                "The Morningstar Sustainability Rating is calculated through a three-step process. "
              }
            </div>
            <div className={"esgText"}>
              {
                "First, Morningstar calculates the Morningstar Portfolio Sustainability Score for every portfolio reported within the trailing 12 months. This score is a historical holdings-based calculation using the company-level ESG Risk Rating from Sustainalytics, a leading provider of ESG research. The Sustainalytics’ company-level ESG Risk Rating measures the degree to which a company’s economic value may be at risk driven by ESG issues. To be considered material to the risk rating, an ESG issue must have a potentially substantial impact on the economic value of a company and therefore on the risk-return profile of an investment in the company. The ESG issues that are material vary across industry groups and companies. "
              }
            </div>
            <div className={"esgText"}>
              {
                "Second, Morningstar uses these scores to calculate a portfolio's Morningstar Historical Portfolio Sustainability Score.  "
              }
            </div>
            <div className={"esgText"}>
              {
                "Third, Morningstar assigns a Morningstar Sustainability Rating for a portfolio based on its Morningstar Historical Portfolio Sustainability Score relative to its Morningstar Global Category."
              }
            </div>
            <div className={"esgText"}>
              {
                "Additionally, Morningstar applies ratings buffers to increase the rating's stability and makes ratings adjustments for portfolios with extreme Morningstar Historical Portfolio Sustainability Scores. "
              }
            </div>
            <div className={"esgText"}>
              {
                "For each product category, 5 globes are assigned to the top 10%, 4 globes to the next 22.5%, 3 globes to the next 35%,2 globes to the next 22.5%, and 1 globe to the bottom 10%."
              }
            </div>
          </div>
          <br /> <br />
        </div>
      );
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    fundData: getFundData(state),
    sortColumn: getSortColumn(state),
    sortDirection: getSortDirection(state),
    levelData: getLevelData(state),
    version: getVersion(state),
  };
}

export default connect(mapStateToProps, {
  loadFundData,
  setSort,
  setLevel,
})(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js